import { api } from "./api";

async function chunkUpload(file, contentType, onProgress) {
  const { data } = await api.post("/videos/init", { filename: file.name.slice(-120), content_type: contentType, size: file.size });
  for (let off = 0, idx = 0; off < file.size; off += data.chunk_size, idx++) {
    const chunk = file.slice(off, off + data.chunk_size);
    for (let tries = 0; ; tries++) {
      try { await api.put(`/videos/${data.upload_id}/chunk?idx=${idx}`, chunk, { headers: { "Content-Type": "application/octet-stream" } }); break; }
      catch (e) { if (tries >= 2) throw e; }
    }
    onProgress(Math.round((Math.min(off + data.chunk_size, file.size) / file.size) * 100));
  }
  return (await api.post(`/videos/${data.upload_id}/complete`)).data.url;
}

export async function uploadVideo(file, onProgress = () => {}) {
  if (!["video/mp4", "video/webm", "video/quicktime"].includes(file.type)) throw new Error("Upload an MP4, WEBM or MOV video");
  if (file.size > 50 * 1024 * 1024) throw new Error("Video too large, max 50 MB (about 1 minute)");
  const secs = await new Promise((res) => { const v = document.createElement("video"); v.preload = "metadata"; v.onloadedmetadata = () => { URL.revokeObjectURL(v.src); res(v.duration); }; v.onerror = () => res(0); v.src = URL.createObjectURL(file); });
  if (secs > 75) throw new Error("Video is too long, keep it under 1 minute");
  return chunkUpload(file, file.type, onProgress);
}

export async function uploadModel(file, onProgress = () => {}) {
  if (!/\.glb$/i.test(file.name)) throw new Error("Upload a .GLB 3D model file");
  if (file.size > 50 * 1024 * 1024) throw new Error("3D file too large, max 50 MB");
  return chunkUpload(file, "model/gltf-binary", onProgress);
}
